import {IParams as SwitchViewModelParams, viewModel as SwitchViewModel} from "./switch";
import radioHtml from './radio.html?raw';

export let template = radioHtml;

interface IParams extends SwitchViewModelParams {
    name: string
}

export class viewModel extends SwitchViewModel {
    constructor(params: IParams) {
        super(params);
    }
}
